/* eslint-disable camelcase */
/**  v2版本eu弹窗
 *
 *  数据支持
 *  eu_data
 *  bus注入
 *  @function defaultConsentGa
 *  @function updateConsentGA
 *  更新数据
 *  @function euPopupInject
 *  @params {object} data info接口数据
 *  @return {void}  副作用函数
 *
 *  组件支持
 *
 *  **/

export const euData = {
  euPolicyShow: false,
  euPolicyContent: '',
  euPolicyChoiceContent: {
    storageText: '',
    adText: ''
  }
}

export const defaultConsentGa = () => {
  window.gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied'
  })
}
export const updateConsentGA = euPolicyChoice => {
  window.gtag('consent', 'update', {
    ad_storage: euPolicyChoice['ad_storage'] === 1 ? 'granted' : 'denied',
    ad_user_data: euPolicyChoice['ad_user_data'] === 1 ? 'granted' : 'denied',
    ad_personalization:
      euPolicyChoice['ad_personalization'] === 1 ? 'granted' : 'denied',
    analytics_storage:
      euPolicyChoice['analytics_storage'] === 1 ? 'granted' : 'denied'
  })
}

export function euPopupInject(data) {
  console.log(data,'data')
  if (data['google_analytics_popup']) {
    defaultConsentGa()
    const {
      popup_content: policyCtx,
      checked: policyHide,
      storage_choice_text,
      ad_choice_text,
      choices
    } = data['google_analytics_popup']
    this.euPolicyShow = !policyHide
    this.euPolicyContent = policyCtx
    this.euPolicyChoiceContent.storageText = storage_choice_text
    this.euPolicyChoiceContent.adText = ad_choice_text
    if (policyHide) {
      updateConsentGA(choices)
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/eu_popup.js